import { createEffect, createSignal } from "solid-js";
import type { useLocation } from "@tanstack/solid-router";

const openNewListDialog = () => {
  // No-op. Dialog is deprecated.
};
const openNewGroupDialog = () => {
  // No-op. Dialog is deprecated.
};
const openChoiceDialog = () => {
  // No-op. Dialog is deprecated.
};
const openEditListDialog = () => {
  // No-op. Dialog is deprecated.
};
const openShareListDialog = () => {
  // No-op. Dialog is deprecated.
};
const openEditGroupDialog = () => {
  // No-op. Dialog is deprecated.
};

const setListDialogOpen = () => {
  // No-op. Dialog is deprecated.
};
const setCreationGroupId = () => {
  // No-op. Dialog is deprecated.
};
const setShareDialogOpen = () => {
  // No-op. Dialog is deprecated.
};
const setSelectedList = () => {
  // No-op. Dialog is deprecated.
};
const setChoiceDialogOpen = () => {
  // No-op. Dialog is deprecated.
};
const setGroupDialogOpen = () => {
  // No-op. Dialog is deprecated.
};
const setEditingGroup = () => {
  // No-op. Dialog is deprecated.
};

export function useAppDialogs(location: ReturnType<typeof useLocation>) {
  const [isSidebarOpen, setIsSidebarOpen] = createSignal(false);
  const [shortcutsOpen, setShortcutsOpen] = createSignal(false);

  createEffect(() => {
    void location().pathname;
    setIsSidebarOpen(false);
  });

  return {
    listDialogOpen: () => false,
    setListDialogOpen,
    creationGroupId: () => undefined,
    setCreationGroupId,
    shareDialogOpen: () => false,
    setShareDialogOpen,
    selectedList: () => null,
    setSelectedList,
    isSidebarOpen,
    setIsSidebarOpen,
    choiceDialogOpen: () => false,
    setChoiceDialogOpen,
    groupDialogOpen: () => false,
    setGroupDialogOpen,
    editingGroup: () => null,
    setEditingGroup,
    shortcutsOpen,
    setShortcutsOpen,
    openNewListDialog,
    openNewGroupDialog,
    openChoiceDialog,
    openEditListDialog,
    openShareListDialog,
    openEditGroupDialog,
  };
}
